import { Injectable } from '@angular/core';
import { CorrespondenceAttachmentInterface } from '@app/core/interfaces/correspondence-attachment.interface';
import { RequestService } from 'outshared-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class DamageClaimService {

    constructor(private request: RequestService) {}

    public getCorrespondence(documentId: string): Observable<CorrespondenceAttachmentInterface> {
        const payload = { correspondence_item: { cynodocs_document_id: documentId } };

        return this.request.post('en-gb/claim-case/request/correspondence_item-cynodocsdocumentid', payload)
            .pipe(map(result => result.data));
    }
}
